module.exports = __webpack_public_path__ + "1531790e292aee17f155f5527bf10ea6.svg";